import(/* webpackMode: "eager" */ "/app/src/app/(secured)/[workspaceId]/page.tsx");
